import { useEffect } from 'react';

import useNavigation from '@Navigation/useNavigation';
import transformUrl from '@Navigation/transformUrl';

/**
 * Эффект для синхронизации регионального слага в текущем адресе с текущим регионом
 * (потребность обусловлена тем, что, например, при навигации назад после смены региона
 * пользователь попадает на страницу со старым региональным слагом)
 */
const useSyncUrl = () => {
  const { pathname, search, replaceUrl } = useNavigation();

  useEffect(() => {
    const transformedUrl = transformUrl({ url: pathname });

    if (transformedUrl !== pathname)
      replaceUrl(`${transformedUrl}${search}${window.location.hash}`);
  }, [pathname, replaceUrl, search]);
};

export default useSyncUrl;
